export default "__VITE_ASSET__BL5EWGLP__"